import {language as lan_keyboardStortcute} from "./keyboard-shortcuts-modal";

let language = {
    // quill快捷键
    ...lan_keyboardStortcute,

    STORE_PRODUCT_SETTING_INFO_CONFIG_PRODUCT_TITLE: "{{appName}} configurable product id:",
    STORE_PRODUCT_SETTING_INFO_ALLOW_REDESIGN:"Allow customers to redesign?",
    STORE_PRODUCT_SETTING_INFO_ALLOW_REDESIGN_DES:"Check this box to allow your customers to change the design of the product prior to adding it to their cart.",
    STORE_PRODUCT_SETTING_INFO_MUST_REDESIGN_DES:"Customers must to change the design of the product prior to adding it to their cart.",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_TITLE:"Product name",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_ERROR_TIP:"Please set the length of the product name to 1 to 60.",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_NAME_ERROR_TIP_PATTERN: "The only valid product name is letters, numbers, punctuation, math symbols, space characters  And ? . You can only use the %, :, &, and + characters once each.",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_SHORT_DES:"Store Product Short Description",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_Small:"Small",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_NORMAL:"Normal",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_LARGE:"Large",
    STORE_PRODUCT_SETTING_INFO_QUILL_EDITOR_FONT_SIZE_HUGE:"Huge",
    STORE_PRODUCT_SETTING_INFO_PRODUCT_DES:"Store Product Description",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_TITLE:"UpdateInfo Error",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_content:"UpdateInfo Error",
    STORE_PRODUCT_SETTING_INFO_UPDATE_ERROR_content_1101173018: "The only valid product name is letters, numbers, punctuation, math symbols, space characters  And ? . You can only use the %, :, &, and + characters once each.",

    
};


export { language }